import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Cerere } from '../../cereri.interface';
import { formConfigurations } from './informatii-aditionale';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
    selector: 'app-informatii-aditionale',
    templateUrl: './informatii-aditionale.component.html',
    styleUrls: ['./informatii-aditionale.component.scss']
})
export class InformatiiAditionaleComponent implements OnChanges {
    @Input() cerere!: Cerere | null;
    selectedInfoStatus = 'info';

    has_checkbox_details = false;

    viewAlteCereri = 0;

    currentFormFields: Array<{
        label: string;
        value: string;
        type?: string;
        isCheckboxField?: boolean;
    }> = [];

    preparedCheckboxDetails: Array<{
        label: string;
        value: boolean;
        type: string;
        isCheckboxField?: boolean;
    }> = [];

    ngOnChanges(changes: SimpleChanges): void {
        this.getCurrentFormFields();
        if (changes['cerere']) {
            let currentSlug = this.cerere?.slug || 'default-slug';

            if (
                currentSlug === 'emitere-cert-urb-retele-tehnico-edilitare' ||
                currentSlug === 'emitere-cert-urb-mijloace-publicitare'
            ) {
                currentSlug = 'emitere-certificat-urbanism'
            } else if (
                currentSlug === 'construction-dem-retele-tehnico-edilitare' ||
                currentSlug === 'construction-dem-mijloace-publicitare'
            ) {
                currentSlug = 'autorizatie-construire-desfiintare'
            }

            this.currentFormFields = formConfigurations[currentSlug] || [];
            this.preparedCheckboxDetails = this.prepareCheckboxDetails(currentSlug);
            this.has_checkbox_details = this.hasValidData(
                this.cerere?.checkbox_details
            );
        }
    }

    getCurrentFormFields(): Array<{
        label: string;
        value: string;
        type?: string;
        isCheckboxField?: boolean;
    }> {
        let currentSlug = this.cerere?.slug || 'default-slug';

        if (
            currentSlug === 'emitere-cert-urb-retele-tehnico-edilitare' ||
            currentSlug === 'emitere-cert-urb-mijloace-publicitare'
        ) {
            currentSlug = 'emitere-certificat-urbanism'
        } else if (
            currentSlug === 'construction-dem-retele-tehnico-edilitare' ||
            currentSlug === 'construction-dem-mijloace-publicitare'
        ) {
            currentSlug = 'autorizatie-construire-desfiintare'
        }

        const allFields = formConfigurations[currentSlug] || [];

        // Mark checkbox fields
        return allFields.map((field) => {
            return {
                ...field,
                isCheckboxField: field.value.includes('.'),
            };
        });
    }

    prepareCheckboxDetails(slug: string): any[] {
        return this.currentFormFields
            .filter((field) => field.value.includes('.')) // Filter to include all checkbox fields
            .map((field) => {
                const value = this.getValueByPath(
                    this.cerere?.checkbox_details,
                    field.value
                );

                // Format value if it's a date
                if (field.type === 'date') {
                    return { ...field, value: this.formatDate(value) };
                }

                return { ...field, value };
            });
    }

    private formatDate(dateString: string): string {
        if (!dateString) return 'N/A';

        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    }

    private getValueByPath(obj: any, path: string): any {
        return path
            .split('.')
            .reduce((o, key) => (o && o[key] !== undefined ? o[key] : null), obj);
    }

    // This function checks if we have values inside a property, we are using this to check if checkbox_details has values or it's an empty array

    private hasValidData(data: any): boolean {
        if (data && typeof data === 'object') {
            return Object.values(data).some((nestedObj) => {
                if (nestedObj && typeof nestedObj === 'object') {
                    return Object.values(nestedObj).some((value) => !!value);
                }
                return false;
            });
        }
        return false;
    }

    onInfoChange(event: MatButtonToggleChange) {
        this.selectedInfoStatus = event.value;
    }

    formatCreatedAt(created_at: string): string {
        return new Date(created_at).toLocaleString('ro-RO');
    }
}
